export default "__VITE_ASSET__DGvvRNYW__"